import { render, staticRenderFns } from "./MantenedorServicios.vue?vue&type=template&id=b488e4d4&scoped=true&"
import script from "./MantenedorServicios.vue?vue&type=script&lang=js&"
export * from "./MantenedorServicios.vue?vue&type=script&lang=js&"
import style0 from "./MantenedorServicios.vue?vue&type=style&index=0&id=b488e4d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b488e4d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b488e4d4')) {
      api.createRecord('b488e4d4', component.options)
    } else {
      api.reload('b488e4d4', component.options)
    }
    module.hot.accept("./MantenedorServicios.vue?vue&type=template&id=b488e4d4&scoped=true&", function () {
      api.rerender('b488e4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/vistas/MantenedorServicios.vue"
export default component.exports